/**
 * `apiboo-hex`: a tiny Monarch grammar for the hex dumps the app shows (the
 * response Hex view, binary DB cells). Shared by ui/CodeEditor and the DB
 * cell editor (dbManager/DbCellCodeEditor).
 *
 * Three token classes, which is all a hex dump has: the OFFSET label, the
 * bytes, and the ASCII gutter. Without it every row is one undifferentiated
 * wall of hex and the offset — the column you actually navigate by — reads as
 * just more bytes. Colours live in utils/monacoThemes.js.
 *
 * Registered once per Monaco instance; `getLanguages` is the guard because
 * this runs on every editor mount.
 */
export function registerHexLanguage(monaco) {
  if (monaco.languages.getLanguages().some((l) => l.id === 'apiboo-hex')) return;
  monaco.languages.register({ id: 'apiboo-hex' });
  monaco.languages.setMonarchTokensProvider('apiboo-hex', {
    tokenizer: {
      root: [
        // `00000000:` at line start — the offset label.
        [/^[0-9a-f]{8}:/, 'hex-offset'],
        // The ASCII gutter, |…| at end of line.
        [/\|.*\|$/, 'hex-ascii'],
        // Everything else that looks like a byte pair.
        [/\b[0-9a-f]{2}\b/, 'hex-byte'],
        [/\[---.*---\]/, 'hex-note'],
      ],
    },
  });
}
